import './free_text_attribute_view.js.coffee'

class Customer.DateAttributeView extends Customer.FreeTextAttributeView
  valueTemplate: JST['backbone/templates/customer/custom_attributes/values/date']
  className: 'custom-attribute date-custom-attribute'

  appendValue: (value) =>
    super.find('.input').datepicker(
      autoclose: true
      format: 'dd-mm-yyyy'
      todayBtn: 'linked'
      todayHighlight: true
      changeMonth: true
      changeYear: true
    )

  afterRender: ->
